import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { AuthShell } from "../components/AuthShell";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function VerifyEmail() {
  const [sp] = useSearchParams();
  const [state, setState] = useState({ s: "loading", m: "" });
  const { refresh } = useAuth();
  const ran = useRef(false);
  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    api.post("/auth/verify-email", { token: sp.get("token") || "" })
      .then(() => { setState({ s: "ok" }); refresh(); })
      .catch((e) => setState({ s: "err", m: errMsg(e) }));
  }, [sp, refresh]);
  return (
    <AuthShell title={state.s === "ok" ? "you're verified" : state.s === "err" ? "link didn't work" : "verifying…"}>
      <div data-testid={`verify-status-${state.s}`} className="text-sm text-zinc-400">
        {state.s === "ok" && "Your email is confirmed. Purchases and everything else are now unlocked."}
        {state.s === "err" && `${state.m}. You can request a fresh link from your dashboard settings.`}
      </div>
      {state.s !== "loading" && <Link to="/dashboard" className="btn-pink mt-6 w-full" data-testid="verify-dashboard-button">go to dashboard</Link>}
    </AuthShell>
  );
}
